import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
const EASE = [0.22, 1, 0.36, 1] as const;

/**
 * Subtle fade, lift and de-blur as content enters the viewport. Plays once.
 * `delay` is in seconds — use small steps (0.06–0.1) to stagger siblings.
 */
export function Reveal({
  children,
  delay = 0,
  className
}: Props) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className} data-id="element-409" data-mp="2ns1snyhyk6qm">{children}</div>;
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 14,
    filter: 'blur(4px)'
  }} whileInView={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} viewport={{
    once: true,
    margin: '0px 0px -10% 0px'
  }} transition={{
    duration: 0.9,
    delay,
    ease: EASE
  }} data-id="element-410" data-mp="2nsjwbg6y9n8k">
      {children}
    </motion.div>;
}